<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>

    <!-- <div
      id="mobile-map"
      style="width: 100%; height: 321px;"
    >
    </div>

    <div class="map">
      <div
        id="map"
        :class="{ hidden: !mapIsLoaded }"
        style="width: 100%; height: 521px;"
      ></div>
      <img
        v-if="!mapIsLoaded"
        class="map-underlay"
        src="/images/map.png"
        alt=""
      >
      <div
        v-if="!mapIsLoaded"
        style="width: 100%; height: 521px;"
      >
        <app-spinner>
        </app-spinner>
      </div>
    </div> -->

    <br>

    <p><a
        href="Центры проведения демонстрационного экзамена, 2021 год"
        target="_blank"
      >Центры проведения демонстрационного экзамена, 2021 год</a></p>
    <p>
      <iframe
        ref="iframeCPDE"
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vS6dg0atx26ySpRGCXmjxh7ehJNtnqXLHvg-Z0_LEAePCuy3EdhalpIdhTP3Pw2sMmqL0AzGJ9lnvsv/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"
        width="100%"
        height="550"
        overflow="hidden"
      >
      </iframe>
    </p>

    <!-- <div class="regions">
      <h3 class="text-sm regions__header">Список по регионам</h3>

      <div class="row">
        <div class="col-sm col-md-6 region-filter">
          <v-select
            :options="groupedRegions"
            v-model="selectedRegion"
            label="region"
            placeholder="Выберите регион"
          >
            <template
              slot="option"
              slot-scope="option"
            >
              {{ option.region}} <span class="count"> {{ option.count }} </span>
            </template>
            <span slot="no-options">Совпадений не найдено</span>
          </v-select>
        </div>

        <div
          v-show="!!selectedRegion"
          class="col-sm col-md-6 align-self-center selected-region"
        >
          <div
            class="selected-region__title"
            v-text="selectedRegion.region"
          ></div>
          <svg
            class="close-icon"
            @click="reset"
          >
            <use xlink:href="#close-black"></use>
          </svg>
        </div>
      </div>

      <div
        v-show="!!selectedRegion"
        class="selected-region-centers"
      >
        <div
          v-for="(centers, city) in selectedRegion.centers"
          :key="city"
          class="center"
        >
          <div
            class="center__city"
            v-text="city"
          ></div>
          <div
            v-for="center of centers"
            :key="center.guid"
            class="center__address"
          >
            <div
              class="center__title"
              v-text="center.title"
            ></div>
            <div
              :class="{ link: isMobile }"
              class="center__address"
              @click="zoomToAddress(center)"
              v-text="center.address"
            ></div>
          </div>
        </div>
      </div>

      <hr>

      <div
        v-show="!selectedRegion"
        class="all-regions"
      >
        <div
          v-for="region in groupedRegions"
          :key="region.region"
          class="region"
        >
          <div
            class="region__title text-sm"
            v-text="region.region"
          ></div>
          <div class="region-centers">
            <div
              v-for="(centers, city) in region.centers"
              :key="city"
              class="center"
            >
              <div
                class="center__city"
                v-text="city"
              ></div>
              <div
                v-for="center of centers"
                :key="center.guid"
                class="center__address"
              >
                <div
                  class="center__title"
                  v-text="center.title"
                ></div>
                <div
                  :class="{ link: isMobile }"
                  class="center__address"
                  @click="zoomToAddress(center)"
                  v-text="center.address"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div> -->

  </div>
</template>
<script>
/*global ymaps*/
import groupBy from "lodash/groupBy";
import cloneDeep from "lodash/cloneDeep";
import { AppPageSearch, AppSpinner } from "@/components";
import { loadCenters } from "@/api";
import MapMaskView from "@/utils/map-mask-view";

const markerOptions = {
  iconLayout: "default#image",
  iconImageHref: "/images/baloon.svg",
  iconImageSize: [15, 23],
  balloonOffset: [120, 110],
  balloonMinWidth: 250,
  balloonMinHeight: 100,
  balloonMaxWidth: 250,
  balloonCloseButton: false,
  balloonShadow: false,
  hideIconOnBalloonOpen: false
};

export default {
  name: "TrainingCenters",
  components: { AppPageSearch, AppSpinner },
  data: () => ({
    regions: [],
    groupedRegions: [],
    title: "Список ЦПДЭ",
    map: "",
    selectedRegion: "",
    collection: "",
    geoObjectsCollection: "",
    geoObjects: "",
    mapIsLoaded: false,
    zoom: 3,
    mobileZoom: 2.5,
    center: [63.156358, 99.640273],
    cachedMarkers: []
  }),
  computed: {
    markers() {
      if (this.selectedRegion) {
        const region = this.regions.find(
          region => region.region === this.selectedRegion.region
        );
        return region.centers.map(center => ({
          lat: center.lat,
          long: center.long,
          address: center.address,
          city: center.city,
          title: center.title
        }));
      }

      if (this.cachedMarkers.length) return this.cachedMarkers;

      return this.regions.reduce((acc, current) => {
        const coords = current.centers.map(center => ({
          lat: center.lat,
          long: center.long,
          address: center.address,
          city: center.city,
          title: center.title
        }));
        return acc.concat(coords);
      }, []);
    }
  },

  watch: {
    async selectedRegion() {
      this.mapIsLoaded = false;
      if (!this.isMobile) this.geoObjectsCollection.removeAll();
      this.map.behaviors.enable(["drag"]);
      this.map.controls.add("zoomControl");

      if (this.selectedRegion) {
        this.createMarkersForRegion();
        const firstCity = Object.keys(this.selectedRegion.centers)[0];
        const center = this.selectedRegion.centers[firstCity][0];

        this.map.setCenter(
          [center.lat, center.long],
          this.isMobile ? 15 : 8,
          this.isMobile ? { duration: 1000 } : {}
        );
      } else {
        this.restoreMarkers();
        if (!this.isMobile) this.geoObjectsCollection.add(this.geoObjects);
        this.map.behaviors.disable(["drag"]);
        this.map.controls.remove("zoomControl");

        this.map.setCenter(
          this.center,
          this.isMobile ? this.mobileZoom : this.zoom,
          this.isMobile ? { duration: 1000 } : {}
        );
      }
      setTimeout(() => {
        this.mapIsLoaded = true;
      }, 300);
    },
    $route() {
      this.checkRoute();
    }
  },

  async created() {
    this.isMobile = window.innerWidth < 1000;

    this.regions = await loadCenters();
    this.groupedRegions = cloneDeep(this.regions);

    this.groupedRegions.forEach(region => {
      const grouped = groupBy(region.centers, center => center.city);
      region.centers = grouped;
    });

    this.isMobile ? this.initMobileMap() : this.initMap();
  },

  methods: {
    initMobileMap() {
      ymaps.ready(() => {
        this.collection = new ymaps.GeoObjectCollection();

        this.map = new ymaps.Map("mobile-map", {
          center: this.center,
          zoom: 2.5,
          behaviors: []
        });

        this.createMarkers();
        this.checkRoute();
      });
    },
    initMap() {
      ymaps.ready(() => {
        this.collection = new ymaps.GeoObjectCollection();

        this.map = new ymaps.Map(
          "map",
          {
            center: this.center,
            zoom: this.zoom,
            behaviors: []
          },
          {
            scrollZoomSpeed: 0,
            dblClickZoomDuration: 0
          }
        );

        this.createMarkers();

        ymaps.regions
          .load("RU", {
            lang: "ru",
            quality: 1
          })
          .then(({ geoObjects }) => {
            this.geoObjectsCollection = new ymaps.GeoObjectCollection();

            this.checkRoute();

            geoObjects.each(geoObject => {
              geoObject.options.set("fillColor", "#23268D");
            });

            this.geoObjects = geoObjects;
            this.geoObjectsCollection.add(geoObjects);

            const mapMask = new MapMaskView(this.map);
            mapMask.clear().render(geoObjects);
            this.map.geoObjects.add(this.geoObjectsCollection);

            setTimeout(() => {
              this.mapIsLoaded = true;
            }, 200);
          });
      });
    },
    checkRoute() {
      if (this.$route.query.title) {
        this.selectedRegion = this.groupedRegions.find(r =>
          this.$route.query.title.includes(r.region)
        );
      }
    },
    createMarkersForRegion() {
      this.collection.removeAll();

      this.markers.forEach(el => {
        const marker = new ymaps.Placemark(
          [el.lat, el.long],
          {
            balloonContent: `
              <div class="balloon">
                <div class="city">${el.city}</div>
                <div class="title">${el.title}</div>
                <div class="address">${el.address}</div>
              </div>`
          },
          markerOptions
        );
        this.collection.add(marker);
      });

      this.map.geoObjects.add(this.collection);
    },
    restoreMarkers() {
      this.collection.removeAll();
      this.markers.forEach(marker => {
        this.collection.add(marker);
      });
      this.map.geoObjects.add(this.collection);
    },
    createMarkers() {
      this.collection.removeAll();
      const markers = [];

      this.markers.forEach(el => {
        const marker = new ymaps.Placemark(
          [el.lat, el.long],
          {},
          markerOptions
        );
        markers.push(marker);
        this.collection.add(marker);
      });

      this.cachedMarkers = markers;
      this.map.geoObjects.add(this.collection);
    },
    zoomToAddress(center) {
      const centers = { [center.city]: [center] };
      this.selectedRegion = { region: center.region, centers };
    },
    reset() {
      this.selectedRegion = "";
      this.$router.replace("/training-centers");
    }
  }
};
</script>

<style lang="scss" scoped>
html {
  overflow: hidden;
}

.hidden {
  visibility: hidden;
}

.link {
  text-decoration: underline;
}

.map-underlay {
  position: absolute;
  top: 27px;
  left: 3px;
  opacity: 0.3;
}

.loader {
  top: 50%;
}

hr {
  margin: 50px 0;
  border-color: #e5e5e5;
  color: #e5e5e5;
  background-color: #e5e5e5;
  border-style: solid;
}

.map {
  padding-top: 35px;
  position: relative;
}

#mobile-map {
  margin-top: 30px;
}
.regions {
  padding-top: 75px;

  &__header {
    margin-bottom: 35px;
  }
}

.regions-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.all-regions {
  column-gap: 1.3em;
  column-count: 3;
}

.region {
  margin-bottom: 20px;
  display: inline-block;
  width: 100%;

  &__title {
    font-weight: 500;
    color: #000;
  }
}

.selected-region {
  &__title {
    display: inline;
    margin-right: 26px;
    margin-left: 78px;
    font-size: 15px;
    line-height: 18px;
    font-weight: 500;
  }

  .close-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    cursor: pointer;
  }
}

.region-centers {
  margin-top: 25px;
}

.selected-region-centers {
  padding-top: 29px;
}

.center {
  font-size: 15px;
  line-height: 15px;
  color: #000;
  margin-bottom: 15px;

  &__city {
    font-weight: 500;
    margin-bottom: 15px;
  }

  &__title {
    font-weight: 700;
    color: #1c3b8d;
    margin-bottom: 10px;
  }

  &__address {
    font-weight: 300;
    margin-bottom: 25px;
  }
}

.count {
  color: #adadad;
}
@include media-breakpoint-only(xs) {
  .selected-region {
    margin-top: 27px;
  }
}
@include media-breakpoint-down(sm) {
  .all-regions {
    column-count: 1;
  }
  .regions {
    padding-top: 22px;
  }

  .region-filter {
    .v-select {
      width: 100%;
    }
  }

  .selected-region {
    &__title {
      margin-left: 0;
    }
  }
}

@include media-breakpoint-only(md) {
  .all-regions {
    column-count: 2;
  }
}

@include media-breakpoint-down(md) {
  .map {
    display: none;
  }
}
@include media-breakpoint-up(lg) {
  #mobile-map {
    display: none;
  }
}
</style>
